const WA = "https://wa.me/917995495312?text=Hi%20Aria%20—%20I%20want%20to%20build%20an%20AI%20workforce";

const EMPLOYEES = [
  { key: "sales", icon: "🤝", title: "AI Sales Representative",
    desc: "Qualifies leads, runs discovery on WhatsApp, schedules demos, follows up on proposals — never forgets a hand-raise." },
  { key: "support", icon: "💬", title: "AI Customer Support Agent",
    desc: "Answers 24/7 across WhatsApp, web, email. Handles FAQs, complaints, refunds, escalations — and learns from every chat." },
  { key: "ops", icon: "🛠️", title: "AI Operations Coordinator",
    desc: "Orchestrates approvals, monitors workflows, chases blocked tasks, and surfaces bottlenecks before they hurt." },
  { key: "hr", icon: "👥", title: "AI HR Assistant",
    desc: "Onboards new hires, answers policy questions, runs leave & expense workflows, and handles routine HR queries." },
  { key: "finance", icon: "💰", title: "AI Finance Assistant",
    desc: "Reads invoices, matches POs, flags exceptions, sends payment reminders, and prepares month-end reports." },
  { key: "docs", icon: "📑", title: "AI Document Processing Agent",
    desc: "Extracts data from invoices, contracts, KYC documents, emails — and pushes structured data into your ERP." },
  { key: "analyst", icon: "📊", title: "AI Business Analyst",
    desc: "Watches your KPIs, spots anomalies, generates insights, and writes the morning brief your leadership team actually reads." },
];

const AIWorkforce = () => (
  <section id="workforce" className="section bg-cream" data-bg="cream" data-testid="workforce-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Build your AI workforce</span>
        <h2 className="section-h2">
          AI employees that work<br />
          <span className="serif">for your business</span>.
        </h2>
        <p className="section-sub">
          Aria helps you deploy AI-powered digital employees that manage leads,
          answer customer queries, process documents, monitor workflows, prepare
          reports, and support your business teams — round the clock.
        </p>
      </div>

      <div className="workforce-grid reveal">
        {EMPLOYEES.map((e) => (
          <article key={e.key} className="workforce-card" data-testid={`workforce-${e.key}`}>
            <div className="workforce-card-head">
              <span className="workforce-icon">{e.icon}</span>
              <div className="workforce-status">
                <span className="workforce-status-dot" />
                Online
              </div>
            </div>
            <h3 className="workforce-title">{e.title}</h3>
            <p className="workforce-desc">{e.desc}</p>
          </article>
        ))}

        <a
          href={WA}
          target="_blank"
          rel="noreferrer"
          className="workforce-card workforce-cta"
          data-testid="workforce-cta"
        >
          <div className="workforce-card-head">
            <span className="workforce-icon workforce-icon-cta">✨</span>
          </div>
          <h3 className="workforce-title">Need a custom AI employee?</h3>
          <p className="workforce-desc">
            We design AI agents for roles unique to your business — built on
            your SOPs, trained on your data, deployed in 2–4 weeks.
          </p>
          <span className="workforce-cta-link">Design your AI employee →</span>
        </a>
      </div>
    </div>
  </section>
);

export default AIWorkforce;
